import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {VaccineService} from '@services/vaccine.service';
import {MedicationService} from '@services/medication.service';
import {splitByUpperCase} from '@/utils/helpers';

@Component({
    selector: 'app-vaccine-detail',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './vaccine-detail.component.html',
    styleUrl: './vaccine-detail.component.scss'
})
export class VaccineDetailComponent implements OnInit {
    public vaccineId: number;
    public vaccineDetail: any;

    public splitByUpperCase = splitByUpperCase;
    public classifications: any[] = [];

    constructor(
        private route: ActivatedRoute,
        private vaccineService: VaccineService,
        private medicationService: MedicationService
    ) {}

    ngOnInit(): void {
        this.vaccineId = this.route.snapshot.params['id'];

        this.medicationService.getClassificationList().subscribe((result) => {
            this.classifications = result;

            if (this.vaccineId) {
                this.getVaccineDetailsInfoById(this.vaccineId);
            }
        });
    }

    getVaccineDetailsInfoById(VaccineId) {
        this.vaccineService
            .getVaccineDetailsInfoById(VaccineId)
            .subscribe((response: any) => {
                this.vaccineDetail = response;

                const classification = this.classifications.find(
                    (c) => c.id === this.vaccineDetail.vaccineTypeId
                );
                this.vaccineDetail.vaccineTypeName =
                    classification?.name ?? '-';
            });
    }
}
